import { render, staticRenderFns } from "./CureSelection.vue?vue&type=template&id=1daace98"
import script from "./CureSelection.vue?vue&type=script&lang=js"
export * from "./CureSelection.vue?vue&type=script&lang=js"
import style0 from "./CureSelection.vue?vue&type=style&index=0&id=1daace98&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports